import firebase from "./firebase";
import dotenv from "dotenv";
import axios from "axios";
import toast from "react-hot-toast";

dotenv.config();

const messaging = firebase.messaging();
messaging.onMessage((payload) => {
  console.log("Message received. ", payload);

  toast.success(payload.notification.title, { duration: 10000 });
  // const notification = new Notification(payload.notification.title);
  // ...
});

export const getToken = (pid, token) => {
  messaging
    .getToken({ vapidKey: process.env.REACT_APP_PUBLIC_VAPID_KEY })
    .then((currentToken) => {
      if (currentToken) {
        localStorage.setItem("fcmToken", currentToken);
        setFCMToken(currentToken, pid, token);
      } else {
        console.log(
          "No registration token available. Request permission to generate one."
        );
      }
    })
    .catch((err) => {
      console.log("An error occurred while retrieving token. ", err);
    });
};
export const setFCMToken = async (fcmToken, pid, token) => {
  if (fcmToken && pid && token) {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/accounts/setFCMToken`,
      {
        pid: pid,
        fcmToken: fcmToken,
        type: "web",
      },

      { headers: { "x-auth-token": token } }
    );
    console.log(data);
  }
};
// export const requestPermission = () => {
//   console.log("Requesting permission...");
//   Notification.requestPermission().then((permission) => {
//     if (permission === "granted") {
//       console.log("Notification permission granted.");
//       // TODO(developer): Retrieve a registration token for use with FCM.
//       // In many cases once an app has been granted notification permission,
//       // it should update its UI reflecting this.

//       if (!localStorage.fcmToken) {
//         messaging
//           .getToken({ vapidKey: process.env.REACT_APP_PUBLIC_VAPID_KEY })
//           .then((currentToken) => {
//             if (currentToken) {
//               console.log(currentToken);
//               localStorage.setItem("fcmToken", currentToken);
//               setFCMToken(currentToken)

//             } else {
//               console.log(
//                 "No registration token available. Request permission to generate one."
//               );
//             }
//           })
//           .catch((err) => {
//             console.log("An error occurred while retrieving token. ", err);
//           });
//       }
//       else{
//         setFCMToken(localStorage.fcmToken)
//       }
//     } else {
//       console.log("Unable to get permission to notify.");
//     }
//   });
// };
